
import React from "react";

const VideoGridEmpty: React.FC = () => {
  return (
    <div className="py-24 text-center">
      <p className="text-muted-foreground">No videos found with the selected filters.</p>
    </div>
  );
};

export default VideoGridEmpty;
